import { useQuery } from '@tanstack/react-query';
import { getTableaux, getCategories } from '../services/tableauxService';

function filtersToParams(filters = {}) {
  const params = {};
  if (filters.search) params.q = filters.search;
  if (filters.category) params.categorie = filters.category;
  if (filters.disponibilite) params.disponibilite = filters.disponibilite;
  if (filters.priceRange?.[0] > 0) params.priceMin = filters.priceRange[0];
  if (filters.priceRange?.[1] < 50000) params.priceMax = filters.priceRange[1];
  return params;
}

export const useTableaux = (filters = {}) => {
  const params = filtersToParams(filters);
  return useQuery({
    queryKey: ['tableaux', params],
    queryFn: () => getTableaux(params),
  });
};

export const useCategories = () => {
  return useQuery({
    queryKey: ['categories'],
    queryFn: async () => {
      const categories = await getCategories();
      return Array.isArray(categories) ? categories : [];
    }
  });
};
